"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _depCheck = _interopRequireDefault(require("../../dep-check"));

var _config = require("./config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var LunaInput = _react["default"].forwardRef(function (props, ref) {
  var className = props.className,
      disabled = props.disabled,
      name = props.name,
      other = props.other,
      placeholder = props.placeholder,
      populated = props.populated,
      postfix = props.postfix,
      prefix = props.prefix,
      size = props.size,
      type = props.type,
      value = props.value,
      defaultValue = props.defaultValue,
      autoComplete = props.autoComplete,
      onChange = props.onChange,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart;
  var eventProps = {
    onBlur: onBlur,
    onChange: onChange,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseDown: onMouseDown,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    onTouchEnd: onTouchEnd,
    onTouchMove: onTouchMove,
    onTouchStart: onTouchStart
  };
  (0, _depCheck["default"])([{
    condition: function condition() {
      return other && other.placeholder;
    },
    message: 'Use of props.other.placeholder will be deprecated. Please use the placeholder prop instead.',
    breakingVersion: 4
  }], props);
  var Elem = type === 'textarea' ? 'textarea' : 'input';
  var id = props.id || name;

  if (!id) {
    throw new Error(_config.ErrorMessages.missingIdOrName);
  }

  var affix = prefix || postfix;
  var isSelectable = _typeof(affix) === 'object';
  var selected, setSelected, isControlled;

  if (isSelectable) {
    var affixId = affix.id || affix.name;
    if (!affixId) throw new Error(_config.ErrorMessages.missingAffixIdOrName);
    if (!affix.options.length) throw new Error(_config.ErrorMessages.missingOptions);
    if (affix.name === name) throw new Error(_config.ErrorMessages.nameEquivalence);
    if (affix.value === undefined && affix.defaultValue === undefined) throw new Error(_config.ErrorMessages.missingInputValue);
    if (affix.value && affix.defaultValue) throw new Error(_config.ErrorMessages.controlledVUncontrolled);
    isControlled = affix.value || false;

    if (isControlled) {
      selected = affix.value;
    } else {
      var _useState = (0, _react.useState)(affix.defaultValue);

      var _useState2 = _slicedToArray(_useState, 2);

      selected = _useState2[0];
      setSelected = _useState2[1];
    }
  }

  var getInputClass = function getInputClass() {
    var _classnames;

    var _classes$input = _config.classes.input,
        base = _classes$input.base,
        small = _classes$input.small,
        populatedClass = _classes$input.populated;
    return (0, _classnames3["default"])(base, (_classnames = {}, _defineProperty(_classnames, small, size === _config.InputSizes.small), _defineProperty(_classnames, populatedClass, !!value || populated), _classnames), className);
  };

  var getWrapperClass = function getWrapperClass() {
    var _classnames2;

    var _classes$wrapper = _config.classes.wrapper,
        base = _classes$wrapper.base,
        hasPrefix = _classes$wrapper.hasPrefix,
        hasPostfix = _classes$wrapper.hasPostfix;
    return (0, _classnames3["default"])(base, (_classnames2 = {}, _defineProperty(_classnames2, hasPrefix, prefix), _defineProperty(_classnames2, hasPostfix, postfix && !prefix), _classnames2));
  };

  var handleClick = function handleClick(event) {
    if (!isControlled) {
      setSelected(event.target.value);
    }

    affix.onChange(event.target.value);
  };

  return _react["default"].createElement("div", {
    className: getWrapperClass()
  }, _react["default"].createElement(Elem, _extends({}, other, {
    ref: ref,
    id: id,
    type: type,
    name: name,
    className: getInputClass(),
    value: value,
    defaultValue: defaultValue,
    autoComplete: autoComplete,
    onChange: onChange,
    disabled: disabled,
    placeholder: other && other.placeholder ? other.placeholder : placeholder
  }, eventProps)), affix && !isSelectable && _react["default"].createElement("label", {
    htmlFor: id,
    className: _config.classes.affix.base
  }, affix), affix && isSelectable && _react["default"].createElement("select", {
    className: _config.classes.affix.base + ' ' + _config.classes.affix.select,
    name: affix.name,
    value: selected,
    disabled: disabled,
    id: affix.id,
    onChange: handleClick,
    onBlur: affix.onBlur,
    onClick: affix.onClick,
    onFocus: affix.onFocus,
    onKeyDown: affix.onKeyDown,
    onKeyUp: affix.onKeyUp,
    onMouseDown: affix.onMouseDown,
    onMouseLeave: affix.onMouseLeave,
    onMouseUp: affix.onMouseUp,
    onTouchEnd: affix.onTouchEnd,
    onTouchMove: affix.onTouchMove,
    onTouchStart: affix.onTouchStart
  }, affix.options.map(function (option, idx) {
    return _react["default"].createElement("option", {
      value: option.value,
      key: idx
    }, option.label);
  })));
});

LunaInput.propTypes = {
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  name: _propTypes["default"].string,
  other: _propTypes["default"].object,
  placeholder: _propTypes["default"].string,
  populated: _propTypes["default"].bool,
  prefix: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
    value: _propTypes["default"].string,
    defaultValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]),
    name: _propTypes["default"].string,
    id: _propTypes["default"].string,
    options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      value: _propTypes["default"].string,
      label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
    })),
    onChange: _propTypes["default"].func,
    onBlur: _propTypes["default"].func,
    onClick: _propTypes["default"].func,
    onFocus: _propTypes["default"].func,
    onKeyDown: _propTypes["default"].func,
    onKeyUp: _propTypes["default"].func,
    onMouseDown: _propTypes["default"].func,
    onMouseLeave: _propTypes["default"].func,
    onMouseUp: _propTypes["default"].func,
    onTouchEnd: _propTypes["default"].func,
    onTouchMove: _propTypes["default"].func,
    onTouchStart: _propTypes["default"].func
  })]),
  postfix: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
    value: _propTypes["default"].string,
    defaultValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]),
    name: _propTypes["default"].string,
    id: _propTypes["default"].string,
    options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      value: _propTypes["default"].string,
      label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
    })),
    onChange: _propTypes["default"].func,
    onBlur: _propTypes["default"].func,
    onClick: _propTypes["default"].func,
    onFocus: _propTypes["default"].func,
    onKeyDown: _propTypes["default"].func,
    onKeyUp: _propTypes["default"].func,
    onMouseDown: _propTypes["default"].func,
    onMouseLeave: _propTypes["default"].func,
    onMouseUp: _propTypes["default"].func,
    onTouchEnd: _propTypes["default"].func,
    onTouchMove: _propTypes["default"].func,
    onTouchStart: _propTypes["default"].func
  })]),
  size: _propTypes["default"].oneOf(Object.values(_config.InputSizes)),
  type: _propTypes["default"].oneOf([].concat(_toConsumableArray(_config.InputTextTypes), ['textarea'])),
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]),
  autoComplete: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  onTouchMove: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func
};
LunaInput.defaultProps = {
  size: _config.InputSizes["default"],
  type: 'text'
};
LunaInput.displayName = 'LunaInput';
var _default = LunaInput;
exports["default"] = _default;
